"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useRouterState = exports.RouterContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _auth = require("@redwoodjs/auth");
var _jsxRuntime = require("react/jsx-runtime");
const RouterStateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const RouterSetContext = /*#__PURE__*/(0, _react.createContext)(undefined);

/***
 *
 * This file splits the context into getter and setter contexts.
 * This was originally meant to optimize the number of redraws
 * See https://kentcdodds.com/blog/how-to-optimize-your-context-value
 *
 */

function stateReducer(state, newState) {
  return {
    ...state,
    ...newState
  };
}
const RouterContextProvider = _ref => {
  let {
    useAuth,
    paramTypes,
    children
  } = _ref;
  const [state, setState] = (0, _react.useReducer)(stateReducer, {
    useAuth: useAuth || _auth.useNoAuth,
    paramTypes
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RouterStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RouterSetContext.Provider, {
      value: setState,
      children: children
    })
  });
};
exports.RouterContextProvider = RouterContextProvider;
const useRouterState = () => {
  const context = (0, _react.useContext)(RouterStateContext);
  if (context === undefined) {
    throw new Error('useRouterState must be used within a RouterContextProvider');
  }
  return context;
};
exports.useRouterState = useRouterState;